module.exports = __webpack_public_path__ + "static/media/f4d-mockup.97bfe8e3.svg";